/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2023-10-08",
    versionChannel: "nightly",
    buildDate: "2023-10-08T00:28:30.656Z",
    commitHash: "b877a39c47cfd4155bf5a19e6e27b8bc40da09b3",
};
